import {ReactNode} from "react";
import {IcnBankFilled, IcnQrCode} from "../assets/icons";

interface TransactionMethodProps {
  text: string;
  icon: ReactNode;
}

export const switchTransactionMethodType = (type: string): TransactionMethodProps => {
  if(type == null){
    return {
        text: 'N/A',
        icon: <IcnBankFilled/>
      };
  }
  switch (type.toLowerCase()) {
    case 'onchain':
      return {
        text: 'Wallet',
        icon: <IcnQrCode/>
      };
    // case 'stablecoin':
    //   return {
    //     text: 'Stablecoin',
    //     icon: <IcnQrCode/>
    //   };
    case 'offramp':
      return {
        text: 'Off-Ramp',
        icon: <IcnBankFilled/>
      };
    case 'onramp':
      return {
        text: 'On-Ramp',
        icon: <IcnBankFilled/>
      };
    default:
      return {
        text: 'N/A',
        icon: <IcnBankFilled/>
      };
  }
};